import $ from "jquery";
import { subscribe, getStoreValue, setStoreValue, getStore } from "@bd-stores";
import analyticView from "@bd-utils/analytic-view";
import ThingItPolling from "@bd-utils/thingit-polling";
import idleTimer from "@bd-utils/idle-timer";
import broadcastInteraction from "@bd-utils/broadcast-interaction";
import broadcastScreenshot from "@bd-utils/broadcast-screenshot";

export const BuildingPage = () => {
  if (!($("#buildingpage").length > 0)) return false;
  let thingItConfig = null;
  let defaultFloorIdIndex = null;
  let activityTimeout;
  let randomIndex;
  let isPaused = false;

  if (window.__CFG__?.others?.thingIt) {
    thingItConfig = window.__CFG__.others.thingIt.config;
    const urlParams = new URLSearchParams(window.location.search);
    const defaultFloor = urlParams.get("floorId");
    let defaultBuildingId = urlParams.get("buildingId");

    setStoreValue(
      "defaultFloorId",
      defaultFloor ?? window.__CFG__.others.thingIt.config.defaultFloorId
    );

    const buildingList = getStoreValue("buildingList");

    const defaultBuildingIdValid = buildingList.some(
      (building) => building.id === defaultBuildingId
    );

    if (!defaultBuildingIdValid) {
      urlParams.delete("buildingId");
      const newUrl = `${window.location.pathname}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`;
      window.history.replaceState({}, '', newUrl);

      defaultBuildingId = window.__CFG__.building.default_building;
    }

    setStoreValue(
      "defaultBuildingId",
      defaultBuildingId
    );

    const currentBuilding = buildingList.find(
      (building) => building.id === defaultBuildingId
    );

    if (currentBuilding) {
      setStoreValue("currentBuilding", currentBuilding);
    }

    window.__CFG__.others.thingIt.config = null;
  }

  const $elms = {
    seeAvailableRoom: $(".floorItem__detail"),
    toggleBuildingImage: $(".js-toggle-building-image"),
    buildingLoader: $("#buildingLoader"),
    buildingFloor: $(".BuildingFloor"),
    buildingPopUp: $("#building-popUp"),
  };

  const flickering = document.querySelector("#Bars");

  const handlePollingData = () => {
    $elms.buildingLoader.toggleClass("is-loading", false);
  };
  
  const initPolling = () => {
    $elms.buildingLoader.addClass("is-loading");
    const thingItPolling = new ThingItPolling(thingItConfig, handlePollingData);
    thingItPolling.initPolling();
  };
  initPolling();

  // sampleBuildingVIsualClass();

  // subscribe to room occupancy
  subscribe(
    (store) => {
      const $current = $elms.toggleBuildingImage.filter(".is-active").first();
      const currentBuilding = getStoreValue("currentBuilding");
      let dataIndex = $current.data("index");
      dataIndex = parseInt(dataIndex) - (currentBuilding?.startFloor ?? 0);

      const buildingId = getStoreValue("defaultBuildingId");
      const currentBuildingMeetingRoom =
        store.meetingRoomAvailability[buildingId] ?? [];
      const currentFloorMeetingRoom =
        currentBuildingMeetingRoom && currentBuildingMeetingRoom[dataIndex]
          ? currentBuildingMeetingRoom[dataIndex]
          : { total: 0, available: 0 };

      const currentBuildingDesk =
        store.workStationAvailability[buildingId] ?? [];
      const currentFloorDesk =
        currentBuildingDesk && currentBuildingDesk[dataIndex]
          ? currentBuildingDesk[dataIndex]
          : { total: 0, available: 0 };

      const meetingRoomAvailability = currentFloorMeetingRoom.available;
      const workStationAvailability = currentFloorDesk.available;

      $("#meeting-room-occupied").html(
        currentFloorMeetingRoom.total - meetingRoomAvailability
      );
      $("#meeting-room-total").html(currentFloorMeetingRoom.total);

      $("#work-station-occupied").html(
        currentFloorDesk.total - workStationAvailability
      );
      $("#work-station-total").html(currentFloorDesk.total);

      let allMeetingRoomAvailability = 0;
      let allWorkStationAvailability = 0;
      const totalMeetingRoom = currentBuildingMeetingRoom.reduce(
        (n, { total }) => n + total,
        0
      );
      const totalWorkStation = currentBuildingDesk.reduce(
        (n, { total }) => n + total,
        0
      );

      if (currentBuildingMeetingRoom.length === 0) {
        $elms.buildingFloor
          .filter('.BuildingFloor')
          .not('.is-disabled')
          .each(function() {
            $(this).addClass('ocl-0');
          });
      }

      for (let i = 0; i < currentBuildingMeetingRoom.length; i++) {
        const currentIndexMeetingRoom = currentBuildingMeetingRoom[i] ?? {
          total: 0,
          available: 0,
        };
        const currentIndexDesk = currentBuildingDesk[i] ?? {
          total: 0,
          available: 0,
        };

        let currentFloorMeetingRoomAvailability =
          currentIndexMeetingRoom.available;
        let currentFloorWorkStationAvailability = currentIndexDesk.available;
        let currentFloorTotalAvailability =
          currentIndexMeetingRoom.total + currentIndexDesk.total;

        // calculate current floor occuppied percentage
        let currentFloorOccupied =
          (currentFloorTotalAvailability -
            currentFloorMeetingRoomAvailability -
            currentFloorWorkStationAvailability) /
          currentFloorTotalAvailability;

        const currentFloorOccupiedClass =
          getOccupiedClass(currentFloorOccupied);

        // add occupied class
        const $currentFloorInfo = $(
          ".buildingOccupancy__toggle[data-index=" + (i + currentBuilding.startFloor) + "]"
        );
        addOccupiedClass(
          $currentFloorInfo,
          currentFloorOccupiedClass.className
        );
        $currentFloorInfo
          .find(".floorIndicator__label")
          .text(currentFloorOccupiedClass.title);

        if (dataIndex == i) {
          let currentMeetingRoomOccupied =
            (currentIndexMeetingRoom.total -
              currentIndexMeetingRoom.available) /
            currentIndexMeetingRoom.total;

          let currentWorkStationOccupied =
            (currentIndexDesk.total - currentIndexDesk.available) /
            currentIndexDesk.total;

          const currentMeetingRoomOccupiedClass = getOccupiedClass(
            currentMeetingRoomOccupied
          );

          const currentworkStationOccupiedClass = getOccupiedClass(
            currentWorkStationOccupied
          );

          addOccupiedClass(
            $("#meetingRoom-wrap"),
            currentMeetingRoomOccupiedClass.className
          );
          addOccupiedClass(
            $("#workStation-wrap"),
            currentworkStationOccupiedClass.className
          );
        }

        allMeetingRoomAvailability += currentFloorMeetingRoomAvailability;
        allWorkStationAvailability += currentFloorWorkStationAvailability;

        // floor occupancy percentage highlight
        const percentage = currentFloorOccupied * 100;
        let base = Math.floor(percentage / 10);
        let modulo = percentage % 10;
        if (modulo > 5) {
          base += 1;
        }
        let highlightPercent = base * 10;
        highlightPercent = highlightPercent > 90 ? 100 : highlightPercent;
        $("#floor" + (i + currentBuilding.startFloor))
          .removeClass(function (index, className) {
            return (className.match(/(^|\s)ocl-\S+/g) || []).join(" ");
          })
          .addClass("ocl-" + highlightPercent);
      }

      // show all floors occupied
      $("#all-meeting-room-occupied").html(
        totalMeetingRoom - allMeetingRoomAvailability
      );
      $("#all-meeting-room-total").html(totalMeetingRoom);

      const meetingRoomText = $("#span-all-meeting-room").text();
      $("#span-all-meeting-room").html(
        totalMeetingRoom + " " + meetingRoomText.replace(/[0-9]/g, "")
      );

      $("#all-work-station-occupied").html(
        totalWorkStation - allWorkStationAvailability
      );
      $("#all-work-station-total").html(totalWorkStation);

      const workstationText = $("#span-all-work-station").text();
      $("#span-all-work-station").html(
        totalWorkStation + " " + workstationText.replace(/[0-9]/g, "")
      );

      // calculate all meeting room occuppied percentage
      let allMeetingRoomOccupied =
        (totalMeetingRoom - allMeetingRoomAvailability) / totalMeetingRoom;
      const meetingRoomOccupiedClass = getOccupiedClass(allMeetingRoomOccupied);
      // add occupied class to all meeting room
      addOccupiedClass(
        $("#allMeetingRoom-wrap"),
        meetingRoomOccupiedClass.className
      );

      // calculate all work station occuppied percentage
      let allWorkStationOccupied =
        (totalWorkStation - allWorkStationAvailability) / totalWorkStation;
      const workStationOccupiedClass = getOccupiedClass(allWorkStationOccupied);

      // add occupied class to all work station
      addOccupiedClass(
        $("#allWorkStation-wrap"),
        workStationOccupiedClass.className
      );
    },
    ["meetingRoomAvailability", "workStationAvailability"]
  );

  // subscribe
  subscribe(
    (store) => {
      disableNonExistingFloors();

      const floors = store.floors;
      const defaultFloorId = store.defaultFloorId;
      const startFloor = store.currentBuilding.startFloor ?? 0;
      const findFloor = Object.keys(floors).find(
        (k) => floors[k].floorId == defaultFloorId
      );

      defaultFloorIdIndex = findFloor
        ? parseInt(findFloor) + startFloor
        : startFloor;

      const $el = $elms.toggleBuildingImage.filter(
        'button[data-index="' + defaultFloorIdIndex + '"]'
      );

      const $buildingElms = $(
        '.BuildingFloor:not([data-index="' + defaultFloorIdIndex + '"])'
      );
      $el.addClass("is-current");
      $el.siblings().removeClass("is-current");
      $el.trigger("click", false);

      resetTimer($buildingElms);
    },
    ["floors"]
  );

  const disableNonExistingFloors = () => {
    const $toggles = $('.buildingOccupancy__toggle');
    const dataIndexValues = [];

    $toggles.each(function() {
      const dataIndex = $(this).data('index');
      dataIndexValues.push(dataIndex);
    });

    $elms.buildingFloor.each(function() {
      const $floor = $(this);
      const dataIndex = $floor.data('index');
      if (!dataIndexValues.includes(dataIndex)) {
        $floor.removeClass('js-toggle-building-image');
        $floor.addClass('is-disabled');
        $floor.off('click');
      }
    });
  }

  const removePopUp = () => {
    $elms.buildingPopUp.addClass("is-inactive");
    $elms.buildingFloor.removeClass("is-flickering");
    setTimeout(function () {
      $elms.buildingPopUp.removeClass("is-active");
    }, 1200);
  };

  const positionSticky = () => {
    let targetFloor = $('.oc-target[data-index="' + randomIndex + '"]');
    let svgElement = targetFloor.get(0);

    if (!targetFloor.length) {
      return;
    }

    let bbox = svgElement.getBBox();
    let matrix = svgElement.getScreenCTM();

    let centerX = bbox.x + (bbox.width / 2);
    let centerY = bbox.y + (bbox.height / 2);

    let centerPoint = svgElement.ownerSVGElement.createSVGPoint();
    centerPoint.x = centerX;
    centerPoint.y = centerY;

    let transformedPoint = centerPoint.matrixTransform(matrix);
  
    $elms.buildingPopUp.css({
      top: transformedPoint.y + 'px',
      left: transformedPoint.x + 'px'
    });
  };

  const resetTimer = () => {
    clearTimeout(activityTimeout);
    activityTimeout = setTimeout(function () {
      randomizeBuildingIndexFlickering();
      $elms.buildingPopUp.removeClass("is-inactive");
      $elms.buildingPopUp.addClass("is-active");
      $elms.buildingFloor
        .filter("[data-index='" + randomIndex + "']")
        .addClass("is-flickering");
      positionSticky();
    }, 120 * 1000);
  };

  const randomizeBuildingIndexFlickering = () => {
    const store = getStore();
    let startFloor = store.currentBuilding?.startFloor ?? 0;
    const floors = store.floors;

    randomIndex = Math.floor(Math.random() * floors.length) + startFloor;
    if (randomIndex === defaultFloorIdIndex) {
      randomizeBuildingIndexFlickering();
    }
  };

  const getOccupiedClass = (percentage) => {
    let classOccupied = "floor-is-not-busy";
    let titleOccupied = window.__CFG__.strings.floorIsNotBusy;
    if (percentage > 0.33 && percentage < 0.67) {
      classOccupied = "floor-is-mildly-busy";
      titleOccupied = window.__CFG__.strings.floorisMildlyBusy;
    } else if (percentage > 0.67 && percentage <= 1) {
      classOccupied = "floor-is-busy";
      titleOccupied = window.__CFG__.strings.floorIsBusy;
    }
  
    return { className: classOccupied, title: titleOccupied };
  };

  const addOccupiedClass = ($targetEl, className) => {
    $targetEl
      .removeClass([
        "floor-is-not-busy",
        "floor-is-mildly-busy",
        "floor-is-busy",
      ])
      .addClass(className);
  };

  const setMeetingRoomAvailability = ($el) => {
    const currentBuilding = getStoreValue("currentBuilding");
    let dataIndex = $el.data("index");
    dataIndex = parseInt(dataIndex) - (currentBuilding?.startFloor ?? 0);

    const storeMeetingRoom = getStoreValue("meetingRoomAvailability");
    const buildingId = getStoreValue("defaultBuildingId");
    const currentFloorMeetingRoom =
      storeMeetingRoom[buildingId] && storeMeetingRoom[buildingId][dataIndex]
        ? storeMeetingRoom[buildingId][dataIndex]
        : { total: 0, available: 0 };

    $("#meeting-room-occupied").html(
      currentFloorMeetingRoom.total - currentFloorMeetingRoom.available
    );
    $("#meeting-room-total").html(currentFloorMeetingRoom.total);

    // calculate cuurent floor occuppied percentage
    let currentFloorOccupied =
      (currentFloorMeetingRoom.total - currentFloorMeetingRoom.available) /
      currentFloorMeetingRoom.total;

    const currentFloorOccupiedClass = getOccupiedClass(currentFloorOccupied);
    addOccupiedClass(
      $("#meetingRoom-wrap"),
      currentFloorOccupiedClass.className
    );
  };

  const setWorkStationAvailability = ($el) => {
    const currentBuilding = getStoreValue("currentBuilding");
    let dataIndex = $el.data("index");
    dataIndex = parseInt(dataIndex) - (currentBuilding?.startFloor ?? 0);

    const storeWorkStation = getStoreValue("workStationAvailability");
    const buildingId = getStoreValue("defaultBuildingId");
    const currentFloorDesk =
      storeWorkStation[buildingId] && storeWorkStation[buildingId][dataIndex]
        ? storeWorkStation[buildingId][dataIndex]
        : { total: 0, available: 0 };

    $("#work-station-occupied").html(
      currentFloorDesk.total - currentFloorDesk.available
    );
    $("#work-station-total").html(currentFloorDesk.total);

    // calculate current floor occuppied percentage
    let currentFloorOccupied =
      (currentFloorDesk.total - currentFloorDesk.available) /
      currentFloorDesk.total;

    const currentFloorOccupiedClass = getOccupiedClass(currentFloorOccupied);
    addOccupiedClass(
      $("#workStation-wrap"),
      currentFloorOccupiedClass.className
    );
  };

  const seeAvailableRoom = (roomType) => {
    analyticView(
      "click",
      `[Button] ${roomType == "meetingroom" ? "Meeting rooms" : "Desks"}`
    );
  };

  const toggleBuildingImage = ($el, withAnalytic = true) => {
    const dataIndex = $el.data("index");
    const targetNumber = $('.numberWrap span[data-index="' + dataIndex + '"]');
    const toggleNumber = $(
      '.buildingOccupancy__toggle[data-index="' + dataIndex + '"]'
    );

    toggleNumber.addClass("is-active");
    $el.siblings().removeClass("is-active");
    targetNumber.addClass("is-active");
    targetNumber.siblings().removeClass("is-active");
    toggleNumber.siblings().removeClass("is-active");
    $(".BuildingFloor").removeClass("is-selected");
    $("#floor" + dataIndex).addClass("is-selected");
    // $("#current-floor").text(floorTitle);

    if (withAnalytic) {
      analyticView("click", `Floor ${dataIndex}`);
    }
  };

  $elms.seeAvailableRoom.on("click", (e) => seeAvailableRoom($(e.currentTarget).data("room")));

  $elms.toggleBuildingImage.on("click", (e, withAnalytic) => {
    const $target = $(e.currentTarget);
    toggleBuildingImage($target, withAnalytic);
    setMeetingRoomAvailability($target);
    setWorkStationAvailability($target);

    $(".floorItem__popUp").addClass("hidden");
  });

  // on idle timeout reset page state
  const onIdleTimeout = () => {
    const activeIndex = $elms.toggleBuildingImage
      .filter("button.is-active")
      .attr("data-index");
    if (activeIndex != defaultFloorIdIndex) {
      $elms.toggleBuildingImage
        .filter('button[data-index="' + defaultFloorIdIndex + '"]')
        .trigger("click", false);
    }
  };

  document.addEventListener("selectstart", function (event) {
    event.preventDefault();
  });

  document.addEventListener(
    "contextmenu",
    function (e) {
      e.preventDefault();
    },
    false
  );

  document.addEventListener("mousemove", function () {
    removePopUp();
    resetTimer();
  });

  $(document).ready(function () {
    const targetToListen = document.querySelector("#building-popUp");
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.attributeName === "style" &&
          mutation.target.style.top === "0px"
        ) {
          removePopUp();
        }
      });
    });
    const config = { attributes: true, attributeFilter: ["style"] };
    observer.observe(targetToListen, config);
  });

  if (flickering) {
    const observer = new MutationObserver((mutations) => {
      let hasChanged = false;
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          const classList = mutation.target?.classList;
          if (classList?.contains("is-flickering")) {
            hasChanged = true;
          }
        }
      });
      if (hasChanged && !isPaused) {
        if (!$(".is-flickering.pauses")[0]) {
          $(".is-flickering, #building-popUp").addClass("pauses");
          setTimeout(function () {
            $(".is-flickering, #building-popUp").removeClass("pauses");
            isPaused = true;
            setTimeout(function () {
              isPaused = false;
            }, 0);
          }, 0);
        }
      }
    });
    observer.observe(flickering, {
      attributeFilter: ["class"],
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  idleTimer(onIdleTimeout);
  broadcastInteraction();
  broadcastScreenshot();
};
